import {useEffect, useState} from "react";
import axios from "axios";
import {delLogin} from "../../slices/user/UserSlice";
import { useDispatch } from 'react-redux';
import {useNavigate} from "react-router-dom";

export default function Timer(props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [clock, setClock] = useState({
        seconds: null,
        minutes: null,
        hours: null,
        // days: null
    })

    useEffect(() => {
        // console.log(Date.parse(subtractHours(new Date(), 2).toISOString()))
        // console.log(getTimeRemaining(1733958829786));
        let interval = setInterval(() =>
            getTimeRemaining(props.endAuthTime), 1000);

        return () => { clearInterval(interval)}

    }, [])

    function handleLogout() {
        // axios.post('/logout')
        //     .then(()=>{
        //         dispatch(delLogin());
        //         localStorage.removeItem('endAuthTime')
        //         console.log("was logout");
        //         navigate('/login')
        //     })
        dispatch(delLogin());
        localStorage.removeItem('endAuthTime')
        console.log("was logout");
        navigate('/')
    }

    function getTimeRemaining(endtimestamp){
        let t = endtimestamp - Date.parse(new Date());
        if (t <= 0) handleLogout();
        var seconds = Math.floor( (t/1000) % 60 ).toString().padStart(2, '0');
        var minutes = Math.floor( (t/1000/60) % 60 ).toString().padStart(2, '0');
        var hours = Math.floor( t/(3600*1000) ).toString().padStart(2, '0');
        setClock({
            // 'days': days,
            'hours': hours,
            'minutes': minutes,
            'seconds': seconds
        });
    }

    return (
            <><span>{clock.hours}</span>:<span>{clock.minutes}</span>:<span>{clock.seconds}</span></>
    )
}